<template>
  <div id="index-practice-list">
    <!-- 学生端模拟练习列表 -->
    <div class="top">
      <div class="title">
        <div class="ti"></div>
        <div class="te">快捷入口</div>
      </div>
      <div class="con">
        <div class="item g" @click="goto(0)">
          <i class="iconfont icon-sequence"></i>顺序练习
          <i class="iconfont icon-duixiangshunxu dd"></i>
        </div>
        <div class="item r" @click="goto(1)">
          <i class="iconfont icon-tucengshunxu"></i>随机练习
          <i class="iconfont icon-suijijian dd"></i>
        </div>
        <div class="item b" @click="goto(2)">
          <i class="iconfont icon-zhiyuanmonitianbao"></i>模拟考试
          <i class="iconfont icon-kaoshi dd"></i>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="title">
        <div class="ti"></div>
        <div class="te">数据统计</div>
      </div>
      <div id="pp" v-if="tip"></div>
      <diy_nothing v-else></diy_nothing>
    </div>

    <diy_dialog
      v-if="dialogData.flag"
      :title="dialogData.title"
      :width="dialogData.width"
      :dialogData="dialogData.dialogData"
      :buttonList="dialogData.buttonList"
      @colseDialog="colseDialog"
      @dialogOper="dialogOper"
    ></diy_dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogData: {
        flag: false,
        title: "选择模拟考试的科目",
        width: "40%",
        tempData: {},
        dialogData: [],
        buttonList: [
          { text: "确定", active: "makesure_choose_subject" },
          { text: "取消", active: "cancel" },
        ],
      },
      optionsList: {
        subject: [], // 科目
        topicnType: [], // 题型
      },
      flag: "",
      tip: true,
    };
  },
  methods: {
    /**
     * 获取科目列表
     */
    async getAllSubjectForSelect() {
      try {
        let resultData = await this.$request({
          url: "/subjects/getAllSubjectForSelect",
          method: "post",
          data: {},
        });
        let subject = [];
        resultData.forEach((element) => {
          let dd = {
            label: element.name,
            value: element.id,
          };
          subject.push(dd);
        });
        this.optionsList.subject = subject;
        this.optionsList.topicnType = this.$questionType;
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 快捷入口跳转事件
     */
    goto(flag) {
      switch (flag) {
        case 0:
          // 跳转至顺序练习界面
          this.dialogData.title = "顺序练习";
          this.dialogData.dialogData = [
            {
              title: "科目",
              value: this.optionsList.subject[0].value,
              type: "select",
              options: this.optionsList.subject,
              key: "subject",
            },
            {
              title: "题型",
              value: "0",
              options: this.optionsList.topicnType,
              type: "select-bk",
              key: "topicnType",
            },
          ];
          this.dialogData.buttonList = [
            { text: "确定", active: "makesure_judge" },
            { text: "取消", active: "cancel" },
          ];
          this.flag = "1";
          this.dialogData.flag = true;
          break;
        case 1:
          // 跳转至随机练习界面
          this.dialogData.title = "顺序练习";
          this.dialogData.dialogData = [
            {
              title: "科目",
              value: "",
              type: "select",
              options: this.optionsList.subject,
              key: "subject",
            },
          ];
          this.dialogData.buttonList = [
            { text: "确定", active: "makesure_judge" },
            { text: "取消", active: "cancel" },
          ];
          this.flag = "0";
          this.dialogData.flag = true;
          break;
        case 2:
          // 跳转至模拟考试界面
          this.$router.push("/practice/exam-list");
          break;

        default:
          break;
      }
    },
    /**
     * 弹出框操作事件
     */
    dialogOper(active) {
      switch (active) {
        case "makesure_judge":
          console.log(this.dialogData.dialogData);
          let routData = {
            flag: this.flag,
          };
          routData = this.$baseData.array2json(
            this.dialogData.dialogData,
            routData
          );
          this.$router.push({
            path: "/practice/exam-practice",
            query: routData,
          });
          break;
        case "cancel":
          this.colseDialog();
          break;

        default:
          break;
      }
    },
    /**
     * 弹出框关闭事件
     */
    colseDialog() {
      this.dialogData.flag = false;
    },
    /**
     * 查看统计
     */
    async practiceByUser() {
      try {
        let resultData = await this.$request({
          url: "/statistics/practiceByUser",
          method: "post",
          data: {},
        });
        if (resultData.length == 0) {
          this.tip = false;
          throw "";
        } else {
          this.tip = true;
        }
        let ddd = [];
        resultData.forEach((element) => {
          let dd = {
            name: element.subject, // 科目
            value: element.doNum, // 做的数量
            totalNum: element.totalNum, // 总数
            trueNum: element.trueNum, // 正确数量
            accuracy: element.accuracy, // 正确率
          };
          ddd.push(dd);
        });
        var datas = [
          ////////////////////////////////////////
          ddd,
        ];
        console.log(datas);
        let option = {
          title: {
            text: "练习错题分布",
            left: "center",
            textStyle: {
              color: "#999",
              fontWeight: "normal",
              fontSize: 14,
            },
          },
          series: datas.map(function (data, idx) {
            return {
              type: "pie",
              // radius: [50, 90],
              left: "center",
              // width: 400,
              itemStyle: {
                borderColor: "#fff",
                borderWidth: 1,
              },
              label: {
                alignTo: "edge",
                formatter:
                  "{b}\n " +
                  "已做: {c}" +
                  "题\n " +
                  "正确: " +
                  // "{@name}" +
                  data[idx].trueNum +
                  "题\n " +
                  "总数:" +
                  data[idx].totalNum +
                  "题\n " +
                  "正确率:" +
                  data[idx].accuracy,
                minMargin: 5,
                edgeDistance: 10,
                lineHeight: 15,
                rich: {
                  time: {
                    fontSize: 10,
                    color: "#999",
                  },
                },
              },
              labelLine: {
                length: 15,
                length2: 0,
                maxSurfaceAngle: 80,
              },
              // labelLayout: function (params) {
              //   const isLeft = params.labelRect.x < myChart.getWidth() / 2;
              //   const points = params.labelLinePoints;
              //   // Update the end point.
              //   points[2][0] = isLeft
              //     ? params.labelRect.x
              //     : params.labelRect.x + params.labelRect.width;
              //   return {
              //     labelLinePoints: points,
              //   };
              // },
              data: data,
            };
          }),
        };
        let myChart = this.$echarts.init(document.getElementById("pp"));
        myChart.setOption(option);
      } catch (error) {
        if (error != "") {
          this.$message.error(error.message);
        }
      }
    },
  },
  async mounted() {
    await this.getAllSubjectForSelect();
    await this.practiceByUser();
  },
};
</script>

<style lang="less" scoped>
#index-practice-list {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 10px 15px;
  box-sizing: border-box;
  flex-direction: column;
  > .top {
    width: 100%;
    height: 25%;
    background-color: #fff;
    margin-bottom: 15px;
    display: flex;
    flex-direction: column;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    > .con {
      width: 100%;
      height: 0;
      flex: 1;
      display: flex;
      padding: 30px;
      padding-top: 18px;
      box-sizing: border-box;
      > .item {
        width: 280px;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-right: 28px;
        border-radius: 3px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        cursor: pointer;
        font-size: 14px;
        position: relative;
        overflow: hidden;
        > i {
          margin-bottom: 10px;
          font-size: 35px;
        }
        > .dd {
          position: absolute;
          right: 5px;
          bottom: 0px;
          opacity: 0.05;
          font-size: 70px;
        }
      }
      > .g {
        color: #3ece70;
        background-color: #ddffe938;
      }
      > .r {
        color: #e46a6a;
        background-color: #ffdde438;
      }
      > .b {
        color: #5e95e7;
        background-color: #dde9ff38;
      }
    }
  }
  > .bottom {
    width: 100%;
    height: 0;
    flex: 1;
    background-color: #fff;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    display: flex;
    flex-direction: column;
  }
  .title {
    width: 100%;
    height: 35px;
    display: flex;
    background-color: #f2f5fd;
    align-items: center;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    > .ti {
      width: 3px;
      height: 15px;
      background-color: @baseColor;
      margin-left: 20px;
    }
    > .te {
      width: auto;
      padding: 0 40px;
      padding-left: 10px;
      box-sizing: border-box;
      height: 100%;
      display: flex;
      align-items: center;
      font-size: 15px;
      font-weight: bold;
      justify-content: center;
    }
  }
  #pp {
    width: 100%;
    height: 0;
    flex: 1;
  }
}
</style>